module.exports = __webpack_public_path__ + "static/media/pw_logo.eb00d831.png";